import { render } from "./ProductSwiper.vue?vue&type=template&id=13d26e4f"
import script from "./ProductSwiper.vue?vue&type=script&lang=js"
export * from "./ProductSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__